<template>
  <div class="" v-loading="loading">
    <div class="" style="margin-bottom: 30px;">
      <el-button type="primary" icon="el-icon-plus" @click="showEditWarehouse">新增仓库</el-button>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#F3F3F3' }"
      max-height="700px"
    >
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label=""  width="80" align="center">
        <template v-slot="scope">
          <div v-if="scope.row.warehouseType === 1" class="warehouseType">自营仓库</div>
          <div v-if="scope.row.warehouseType === 3" class="warehouseType">平台共享</div>
        </template>
      </el-table-column>
      <el-table-column label="仓库名(CN)" prop="namec" width="120" align="center"></el-table-column>
      <el-table-column label="仓库名(EN)" prop="namee" width="120" align="center"></el-table-column>
      <el-table-column label="仓库城市" prop="cityName" width="120" align="center"></el-table-column>
      <el-table-column label="仓库类型" prop="warehouseTypeName" width="120" align="center"></el-table-column>
      <el-table-column label="仓库地址" prop="address" min-width="100" align="center"></el-table-column>
      <el-table-column label="详细地址(CN)" prop="addressc" min-width="200" align="center"></el-table-column>
      <el-table-column label="详细地址(EN)" prop="addresse" min-width="200" align="center"></el-table-column>
      <el-table-column label="仓库联系人" prop="contactPerson" width="100" align="center">
        <template slot-scope="scope">
          {{scope.row.contactPerson || ''}}
          <br/>
          {{scope.row.tel || ''}}
        </template>
      </el-table-column>
      <el-table-column label="默认" prop="isDefaultWarehouse" width="50" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isDefaultWarehouse" style="color:#67C23A;">是</span>
          <span v-else style="color:#999;">否</span>
        </template>
      </el-table-column>
      <el-table-column label="录入人" prop="inputer" width="80" align="center"></el-table-column>
      <el-table-column label="录入时间" prop="createTimeText" width="100" align="center">
        <!--<template slot-scope="scope">-->
          <!--{{scope.row.inputTime}}-->
        <!--</template>-->
      </el-table-column>
      <el-table-column label="操作" min-width="160" fixed="right">
        <template v-slot="scope">
          <template v-if="scope.row.warehouseType !== 3">
            <el-button size="mini" @click="showEditWarehouse(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteWarehouse(scope.row)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="paging-row"
                   background
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[5,10,15, 20]"
                   :page-size="pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalListNum">
    </el-pagination>

    <el-dialog
      title="新增国内仓"
      width="740px"
      :visible.sync="visibleEditWarehouse"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
      <div class="el-dialog__title" slot="title" style="text-align: center;">{{formEditWarehouse.id?'修改':'新增'}}仓库</div>
      <el-form :model="formEditWarehouse"
               ref="formNameEditWarehouse"
               :rules="formRulesEditWarehouse"
               :inline="true"
               label-width="120px">
        <el-form-item label="仓库中文名" prop="namec">
          <el-input v-model="formEditWarehouse.namec" class="edit-warehouse__input" placeholder="" ></el-input>
        </el-form-item>
        <el-form-item label="仓库英文名" prop="namee">
          <el-input v-model="formEditWarehouse.namee" class="edit-warehouse__input" placeholder=""></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="仓库所在地" prop="areaId">
          <el-cascader placeholder="请选择仓库所在省市区"
                       ref="region"
                       v-model="provincesValues"
                       @change="changeProvinces"
                       :options="provincesList"
                       :props="{value:'value',label:'namec'}"
                       style="width: 200px;"></el-cascader>
        </el-form-item>
        <el-form-item label="仓库类型" prop="warehouseType">
          <el-select v-model="formEditWarehouse.warehouseType" style="width: 200px;">
            <el-option label="专线自营仓" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <br>

        <el-form-item label="中文详细地址" prop="addressc">
          <el-input v-model="formEditWarehouse.addressc" class="edit-warehouse__input" placeholder="" ></el-input>
        </el-form-item>
        <el-form-item label="英文详细地址" prop="addresse">
          <el-input v-model="formEditWarehouse.addresse" class="edit-warehouse__input" placeholder="" ></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="仓库联系人" prop="contactPerson">
          <el-input v-model="formEditWarehouse.contactPerson" class="edit-warehouse__input" placeholder="" ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel">
          <el-input v-model="formEditWarehouse.tel" class="edit-warehouse__input" placeholder="" ></el-input>
        </el-form-item>
        <br/>
        <el-form-item label="默认收货仓" prop="isDefaultWarehouse">
          <el-switch
            v-model="formEditWarehouse.isDefaultWarehouse"
            inactive-color="#cccccc"
          ></el-switch>
        </el-form-item>

        <div class="edit-warehouse__footer">
          <el-button type="" @click="hideEditWarehouse">取消</el-button>
          <el-button type="primary" @click="submitForm('formNameEditWarehouse')">保存</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import dayJs from 'dayjs'
    function baseDataWarehouse(){
      return {
        id:'',
        // type:1, //  仓库类型 1-国内 2-国外
        namec:'', // 仓库中文名
        namee:'', // 仓库英文名
        countryProvinceId:'',  //  省
        cityId:'',      //  市
        areaId:'',    //  区县
        // address:'',    //  仓库地址
        addressc:'', // 中文详细地址
        addresse:'', // 英文详细地址
        contactPerson:'', // 联系人
        tel:'', // 联系电话
        isDefaultWarehouse:false,  //  是否默认
        warehouseType: '', //  仓库类型 1-自营
      }
    }
    export default {
      name: "warehouseManagement",
      data(){
          return{
            loading:false,
            /* 筛选 */
            searchData:{
              searchValue:'',
              searchType:'',
            },
            /* 表格 */
            tableData:[],
            /* 分页参数 */
            pageSize:10,
            totalListNum:10,
            currentPage: 1,
            /* 新增 */
            visibleEditWarehouse:false,
            formRulesEditWarehouse:{
              namec:[
                {trigger: 'blur',required:true,message:'仓库名不能为空', },
              ],
              // namee:[
              //   {trigger: 'blur',validator:(rule, value, callback) =>{
              //     if(value.length === 0) return callback();
              //     if(/^[a-zA-Z]([a-zA-Z\s\d\-_.]+)/ig.test(value)) callback();
              //     callback(new Error('两位以上，由英文开头'));
              //     },},
              // ],
              province:[
                {trigger: 'blur',required:true,message:'省份 不能为空'},
              ],
              cityId:[
                {trigger: 'blur',required:true,message:'市区 不能为空'},
              ],
              areaId:[
                {trigger: 'blur',required:true,message:'区县 不能为空'},
              ],
              addressc:[
                {trigger: 'blur',required:true,message:'中文详细地址 不能为空'},
                {trigger: 'blur',min:4,max:40,message:'中文详细地址 4~40位'},
              ],
              contactPerson:[
                {trigger: 'blur',required:true,message:'联系人 不能为空'},
                {trigger: 'blur',pattern:/^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z\s]){2,20}$/,message:'联系人2~20位（中/英文）'},
              ],
              tel:[
                {trigger: 'blur',required:true,message:'联系方式 不能为空'},
                {trigger: 'blur',pattern:/^\d[\d-]{6,12}$/,message:'7~13位数，由数字、中划线组成'},
              ],
              warehouseType: [{ required: true, message: '仓库类型 不能为空', trigger: 'blur' }],
            },  // 表单校验规则
            formEditWarehouse:baseDataWarehouse(), // 编辑表单
            provincesList:[],// 省市区列表
            provincesValues:[],//
          }
      },
      created() {
        this.getList();
      },
      methods:{
        /** 获取 列表 */
        getList(){
          return new Promise((resolve,reject) => {
            let data = {
              customerid:this.$store.state.Authorization.customerid
            };
            this.loading = true;
            this.axios.get('/carrier/base/findCarrierWarehouseList',{params: data}).then(res=>{
              let list = res.data.datas || [];
              list.forEach(res=>{
                if(res.inputtime) res.createTimeText = dayJs(res.inputtime).format('YYYY-MM-DD HH:mm:ss');
              });
              this.tableData = list;
              this.totalListNum = res.data.total;
              resolve(res);
            }).catch(res=>{
              this.tableData = [];
            }).finally(res=>{
              this.loading = false;
            })
          })
        },
        /**
         * pageSize 改变时会触发：选择每页显示条数
         */
        handleSizeChange(val, type) {
          this.pageSize = val;
          this.currentPage = 1;
          this.getList()
        },
        /**
         * currentPage 改变时会触发：选择页数
         */
        handleCurrentChange(val, type) {
          this.currentPage = val;
          this.getList();
        },
        /**
         * 显示、隐藏编辑弹窗
         */
        showEditWarehouse(row = null){
          if(row && typeof row === 'object'){
            this.formEditWarehouse = Object.assign(baseDataWarehouse(),row);
          }else{
            this.formEditWarehouse = baseDataWarehouse();
          }
          if(row.id) this.provincesValues = [row.countryProvinceId||'', row.cityId||'', row.areaId||''];
          else this.provincesValues = [];
          if(!this.provincesList.length) this.getProvincesList();
          this.visibleEditWarehouse = true;
        },
        hideEditWarehouse(){
          this.visibleEditWarehouse = false;
        },
        /**
         * 获取省市区列表
         */
        getProvincesList(){
          this.loading = true;
          this.axios.post('/filedata/filedataProvinces').then(res=>{
            this.provincesList = res.data.datas;
          }).finally(res=>{
            this.loading = false;
          })
        },
        changeProvinces(value){
          let [province,city,area] = value;
          this.formEditWarehouse.countryProvinceId = province;
          this.formEditWarehouse.cityId = city;
          this.formEditWarehouse.areaId = area;
          // let selection = this.$refs.region.getCheckedNodes()[0];
          // let node = selection.path;
          // let labels = selection.pathLabels;
          // console.log(selection,node,labels);
          // return {node, labels, selection}
        },
        /**
         * 表单提交
         */
        submitForm(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // console.log(this.formEditWarehouse)
              this.saveWarehouse();
            } else {
              this.$message.error('请补全表单');
              return false;
            }
          });
        },
        /**
         * 新增/修改仓库
         */
        saveWarehouse(data = this.formEditWarehouse){
          let typeText = '修改';
          let params = Object.assign({},data);
          if(!params.id) {
            typeText = '新增';
            delete params.id;
          }
          this.loading = true;
          this.axios.post('/carrier/base/createCarrierWarehousen',params).then(res=>{
            this.$message.success(typeText + '成功');
            this.hideEditWarehouse();
            this.getList();
          }).catch(res=>{
            this.$message.error(res.message || res.msg|| (typeText + '失败，稍后重试'));
          }).finally(()=>{
            this.loading = false;
          })
        },
        /**
         * 删除仓库
         */
        deleteWarehouse(row){
          if(!(typeof row === 'object'&& row.id)) return this.$message.error('id异常');
          this.$confirm(`确认要删除${row.namec? row.namec :'该'}仓库吗？`,'删除仓库',{
            confirmButtonText: '删除',
            type: 'error'
          }).then(() => {
            this.loading = true;
            this.axios.get('/carrier/base/deleteCarrierWarehousen/'+row.id).then(res=>{
              this.$message.success('删除成功');
              this.getList();
            }).catch(res=>{
              if(res.msg || res.message) this.$message.error(res.msg || res.message);
            });
          })
        }
      },
    }
</script>

<style scoped lang="less">
  .paging-row{
    text-align: center;
    margin-top: 50px;
    width: 100%;
  }
  .edit-warehouse__input{
    width: 200px;
  }
  .edit-warehouse__footer{
    display: block;
    margin: 30rpx auto;
    text-align: center;
    .el-button{
      min-width: 120px;
      & + .el-button{
        margin-left: 30px;
      }
    }
  }
  .warehouseType {
    width: 70px;
    height: 20px;
    border-radius: 10px;
    word-break: break-all;
    color: #fff;
    line-height: 20px;
    background: #FF4D01;
  }
</style>



// WEBPACK FOOTER //
// src/components/baseData/warehouseManagement.vue